<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>结算授权</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          @click="$router.push('/authorizationAdd')"
          class="btn"
          >添加授权</el-button
        >
        <TableScrollSlider :table-ref="$refs.multipleTable" />
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          ref="multipleTable"
        >
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="交易流水号" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.tranNo }}</template>
          </el-table-column>
          <el-table-column label="电子台账编号" align="center" width="150">
            <template slot-scope="scope">
              {{ scope.row.virtualAcctNo }}</template
            >
          </el-table-column>
          <el-table-column label="单笔最大金额" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.amtMaxOrder }}</template>
          </el-table-column>
          <el-table-column label="单日最大金额" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.amtMaxDay }}</template>
          </el-table-column>
          <el-table-column label="当前授权状态" align="center" width="120">
            <template slot-scope="scope">
              <span class="greenColor" v-if="scope.row.authStatus == 0"
                >申请中</span
              >
              <span class="greenColor" v-if="scope.row.authStatus == 1"
                >生效中</span
              >
              <span class="redColor" v-if="scope.row.status == 2">已失效</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="startDate"
            label="授权开始时间"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="endTime"
            label="授权到期时间"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="授权手机号" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.authPhone }}</template>
          </el-table-column>
          <el-table-column label="授权操作人" align="center" width="120">
            <template slot-scope="scope"> {{ scope.row.creatorName }}</template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$axios
        .post(`/admapi/settlement/getSettleAuthRecordList`, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
